<script setup lang="ts">
import { Mail } from "@iconoir/vue";

const shortInstructionUrl = `https://docs.${document.location.hostname}/kurzanleitung.pdf`;
</script>

<template>
  <div class="container container-lg box">
    <p>
      Hast du Probleme bei der Nutzung der App? Dann wende dich an unseren
      Support. Wir helfen dir gerne weiter!
    </p>
    <p>
      Bitte beachte, dass sich der Kiezkompass in einer Testphase befindet.
      Daher sind noch nicht alle Features verfügbar. Eine Übersicht findest du
      in unserer <a :href="shortInstructionUrl">Kurzanleitung</a>.
    </p>
    <p>Liebe Grüße,<br />Dein about:source Team</p>
    <p>
      <a href="mailto:kiezkompass@aboutsource.net" class="button" role="button"
        ><Mail />Support kontaktieren</a
      >
    </p>
  </div>
</template>
